import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllAtribuicaoListaUseCase } from "../../../presentation/useCases/read/get_all_atribuicao_lista_use_case";
import { AtribuicaoGrupo } from "../../models/atribuicao_grupo";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetAllAtribuicaoListaUseCase
 */

export class GetAllAtribuicaoListaUseCase extends BasePaginatedUseCase<AtribuicaoGrupo> implements IGetAllAtribuicaoListaUseCase {
  constructor(private readonly repository: IAdministracaoRepository) {
    super();
  }

  async execute(
    page: number,
    rowsPerPage: number,): Promise<void> {

    const result = await this.repository.getAllAtribuicaoGrupoLista(page, rowsPerPage);

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
